module.exports = __webpack_public_path__ + "static/media/favicon.7331d9cb.ico";